import { addMessages } from '@hana/i18n';

// Khoá chuỗi tab Tổng quan + Nhân sự của Lys (tiền tố bod.ov.* / bod.hr.*).
addMessages('vi', {
  'bod.ov.jobSub':'+32,2% so kỳ trước',
  'bod.ov.chatS':'hỏi lịch tàu',
  'bod.ov.xeS':'50E-139.70 · hạn 05/Nov',
  'bod.ov.attn': 'Điểm cần chú ý',
  'bod.ov.setGoal': 'Đặt mục tiêu',
  'bod.ov.test': 'Gửi thử',
  'bod.ov.chg': 'Đổi lịch',
  'bod.ov.job': 'Job trong kỳ',
  'bod.ov.hc': 'Nhân sự',
  'bod.ov.people': 'người',
  'bod.ov.hcSub': '2 vào mới · 1 nghỉ việc',
  'bod.ov.slaSub': '3 mail quá hạn hôm nay',
  'bod.ov.fleet': 'Đội xe',
  'bod.ov.fleetSub': 'xe đang chạy · đúng giờ 94%',
  'bod.ov.pin': 'Ghim lên Tổng quan · {k}',
  'bod.ov.unpin': 'Bỏ ghim · {k}',
  'bod.ov.asg': 'Bình luận / giao việc · {k}',
  'bod.ov.asgT': 'Bình luận / giao việc',
  'bod.ov.pinMax': 'Tối đa 6 chỉ số ghim · bỏ bớt một chỉ số trước',
  'bod.ov.g.ok': 'Đúng tiến độ',
  'bod.ov.g.mid': 'Chậm nhẹ',
  'bod.ov.g.bad': 'Chậm',
  'bod.ov.g.pct': '{p} mục tiêu · thời gian đã qua {t}%',
  'bod.ov.g.mk': 'Mốc theo tiến độ thời gian',
  'bod.ov.g.yoy': 'cùng kỳ {v} · {d}',
  'bod.ov.q1': 'Vì sao job tháng 10 tăng so tháng 9?',
  'bod.ov.a1': 'Job Oct/2026: 501, Sep/2026: 379 (+32,2%).\nTăng chủ yếu ở OB: 419 so 306 (+113), nhiều nhất tuyến CNNGB và KRPUS. LS +8, TR gần như không đổi.\nTháng 9 thấp vì có nghỉ lễ 2/9 (theo WorkCalendar) và 2 hãng giảm chuyến.',
  'bod.ov.q2': 'Phòng nào đi muộn nhiều nhất quý này?',
  'bod.ov.a2': 'Q4/2026 (đến 22/Oct): CS 3 lượt, OPS 1, SALE 1.\nCS vượt mốc cảnh báo 2 lượt / phòng; 2 trong 3 lượt rơi vào thứ Hai. Giờ vào ca lấy theo WorkCalendar (tblClientInfo).',
  'bod.ov.q3': 'Hộp mail nào đang kéo SLA xuống?',
  'bod.ov.a3': 'support@ 89%, dưới mốc 90%. 2 trong 3 mail quá hạn hôm nay thuộc support@, đều đến cuối ca chiều.\nTrả lời trung bình support@ 26′, các hộp khác 12–21′.',
  'bod.ov.q4': 'Xe nào trễ giờ nhiều nhất tháng này?',
  'bod.ov.a4': '50E-139.70: 88% đúng giờ, 4 chuyến trễ > 1 giờ, đều tuyến Cát Lái → Bình Dương giờ cao điểm.\nXe này cũng sắp hạn đăng kiểm 05/Nov.',
  'bod.ov.askS': 'hỏi số liệu · có nguồn',
  'bod.ov.askIn': 'Hỏi Ask HANA về số liệu',
  'bod.ov.askPh': 'Hỏi về số liệu · ví dụ: vì sao SLA support@ giảm?',
  'bod.ov.askGo': 'Hỏi',
  'bod.ov.free': 'Câu hỏi của bạn',
  'bod.ov.freeA': 'Câu này chưa có trong dữ liệu mẫu của board. Bản thật: Ask HANA tra số trong Lys theo quyền của bạn và ghi nguồn từng con số.',
  'bod.ov.src': 'Nguồn',
  'bod.ov.ro': 'Chỉ đọc số liệu · không tự giao việc hay gửi đi',
  'bod.ov.asgFrom': 'Giao việc từ đây',
  'bod.ov.askHint': 'Trả lời kèm nguồn: board, bảng dữ liệu, kỳ. Chỉ đọc theo quyền của bạn.',
  'bod.ov.openAt': 'Mở ở {app}',
  'bod.ov.asgOf': 'Giao việc · {k}',
  'bod.ov.trend': 'Xu hướng 12 tháng',
  'bod.ov.trendS': 'job theo tháng · đường cam = cùng kỳ năm trước',
  'bod.ov.trendA': 'Job theo tháng so cùng kỳ năm trước',
  'bod.ov.ly': 'Cùng kỳ năm trước',
  'bod.ov.peak': 'đỉnh {v} job',
  'bod.ov.pinned': 'Đã ghim',
  'bod.ov.pinnedS': '{n}/6 chỉ số · ghim ở góc chỉ số bất kỳ trong Lys',
  'bod.ov.pinNone': 'Chưa ghim chỉ số nào. Bấm biểu tượng ghim ở góc một chỉ số (Tổng quan, Nhân sự, SLA, Đội xe) để đưa lên đầu trang.',
  'bod.ov.gY': 'Mục tiêu năm 2026',
  'bod.ov.gYS': 'thực tế / mục tiêu · vạch dọc = thời gian đã qua',
  'bod.ov.gQ': 'Mục tiêu Q4/2026',
  'bod.ov.gQS': 'đến 22/Oct/2026',
  'bod.ov.y2026': 'năm 2026',
  'bod.ov.teu': 'quy đổi từ container',
  'bod.ov.newc': 'Khách mới',
  'bod.ov.newcS': 'có job đầu tiên',
  'bod.ov.attnS': 'gộp từ mọi vùng · bấm để mở đúng màn ở vùng gốc',
  'bod.ov.a.loss': 'Job lỗ trong kỳ',
  'bod.ov.a.lossS': '3 job đã ghi sai sót KPE',
  'bod.ov.a.cut': 'Cut-off < 48h chưa đủ SI / VGM',
  'bod.ov.a.cutS': 'mốc cut-off theo luật SOP hãng tàu',
  'bod.ov.a.mail': 'Mail khách quá SLA',
  'bod.ov.a.chat': 'Chat khách chờ > 30′',
  'bod.ov.a.hd': 'Hợp đồng LĐ hết hạn trong 30 ngày',
  'bod.ov.a.xe': 'Xe sắp hạn đăng kiểm',
  'bod.ov.a.kpe': 'Sai sót chờ BOD duyệt',
  'bod.ov.cmp': 'So kỳ trước',
  'bod.ov.cmpS': 'tăng / giảm · cùng kỳ năm trước',
  'bod.ov.cmpJob': 'Job · cùng kỳ năm trước',
  'bod.ov.cmpCus': 'Khách có job',
  'bod.ov.cmpMail': 'Mail trả lời TB',
  'bod.ov.cmpMailV': '18′ · nhanh hơn 3′',
  'bod.ov.cmpLate': 'Đi muộn',
  'bod.ov.cmpLateV': '5 lượt · +2',
  'bod.ov.cmpFl': 'Chuyến xe đúng giờ',
  'bod.ov.cmpFlV': '94% · −1 điểm',
  'bod.ov.asgP': 'Bình luận & việc đã giao',
  'bod.ov.asgPS': 'từ chỉ số · người nhận được báo qua Hei',
  'bod.ov.asgD1': 'Hạn 2 ngày làm việc',
  'bod.ov.asgD2': 'Bình luận',
  'bod.ov.news': 'Bản tin định kỳ',
  'bod.ov.newsS': 'đang bật · Mail + Hei',
  'bod.ov.nw1': 'Lịch gửi',
  'bod.ov.nw1v': 'Hằng tuần · thứ Hai · 07:30',
  'bod.ov.nw2': 'Giờ & ngày nghỉ',
  'bod.ov.nw2v': 'theo WorkCalendar',
  'bod.ov.nw3': 'Nội dung',
  'bod.ov.nw3v': 'Chỉ số đã ghim + Điểm cần chú ý',
  'bod.ov.nw4': 'Người nhận',
  'bod.ov.nw5': 'Lần gửi tới',
  'bod.ov.nw5v': 'Thứ Hai 26/Oct/2026 · 07:30',
  'bod.hr.k.now': 'Nhân sự hiện có',
  'bod.hr.k.in': 'Vào mới',
  'bod.hr.k.inSub': 'trong kỳ',
  'bod.hr.k.out': 'Nghỉ việc',
  'bod.hr.k.outSub': 'tỷ lệ 12 tháng 8% · mốc 10%',
  'bod.hr.k.late': 'Đi muộn / về sớm',
  'bod.hr.turn': 'lượt',
  'bod.hr.k.lateSub': 'mốc cảnh báo 6 lượt',
  'bod.hr.k.leave': 'Phép năm đã dùng',
  'bod.hr.k.leaveSub': '4 người tồn > 10 ngày',
  'bod.hr.k.review': 'Đánh giá cuối năm',
  'bod.hr.k.reviewSub': 'đã tự đánh giá',
  'bod.hr.ch1': 'Nhân sự 12 tháng',
  'bod.hr.ch1s': 'người cuối tháng · nguồn Mee · TblStaff',
  'bod.hr.ch1y': 'đỉnh 36 người',
  'bod.hr.byDept': 'Đi muộn theo phòng',
  'bod.hr.byDeptS': 'kỳ này · mốc 2 lượt',
  'bod.hr.ch2': 'Đi muộn / về sớm theo tháng',
  'bod.hr.ch2s': 'lượt · giờ vào ca theo WorkCalendar',
  'bod.hr.ch2m': 'Mốc cảnh báo 6',
  'bod.hr.ch3': 'Làm thêm giờ theo tháng',
  'bod.hr.ch3s': 'giờ · tính theo WorkCalendar (tblClientInfo)',
  'bod.hr.ch3l': 'Giờ làm thêm',
  'bod.hr.ch3y': 'đỉnh 70 giờ',
  'bod.hr.rank': 'Xếp hạng phòng',
  'bod.hr.ranks': 'kỳ này · không kèm lương',
  'bod.hr.c.dept': 'Phòng',
  'bod.hr.c.n': 'Nhân sự',
  'bod.hr.c.late': 'Đi muộn',
  'bod.hr.c.leave': 'Phép đã dùng',
  'bod.hr.c.ot': 'Làm thêm (giờ)',
  'bod.hr.c.err': 'Sai sót hiệu lực',
  'bod.hr.c.rew': 'Khen thưởng',
  'bod.hr.c.prod': 'Năng suất',
  'bod.hr.mile': 'Mốc cảnh báo',
  'bod.hr.mileS': 'vượt mốc là hiện ở Tổng quan',
  'bod.hr.a1': 'Đi muộn phòng CS vượt mốc',
  'bod.hr.a1s': 'mốc 2 lượt / phòng / tháng',
  'bod.hr.a3': 'Phép tồn > 10 ngày cuối năm',
  'bod.hr.a3s': 'nhắc lịch nghỉ trước 31/Dec',
  'bod.hr.a4': 'Chưa tự đánh giá cuối năm',
  'bod.hr.a4s': 'hạn theo lịch đánh giá',
  'bod.hr.a5': 'Tỷ lệ nghỉ việc 12 tháng',
  'bod.hr.a5s': 'dưới mốc 10%',
  'bod.hr.prod': 'Năng suất',
  'bod.hr.prodS': 'không kèm lương',
  'bod.hr.p1': 'Job / nhân viên vận hành',
  'bod.hr.p2': 'Mail xử lý / CS / ngày',
  'bod.hr.p3': 'Chuyến / tài xế',
  'bod.hr.p4': 'Giờ làm thêm',
  'bod.hr.p4v': '64 giờ · theo WorkCalendar',
  'bod.hr.dept': 'Theo phòng',
  'bod.hr.deptS': 'nguồn HANA Mee · TblStaff',
  'bod.hr.ppl': 'Cần chú ý · cá nhân',
  'bod.hr.pplS': 'đi muộn trong kỳ · mở hồ sơ',
  'bod.hr.times': '{n} lượt',
});
addMessages('en', {
  'bod.ov.jobSub':'+32.2% vs previous period',
  'bod.ov.chatS':'asks about vessel schedule',
  'bod.ov.xeS':'50E-139.70 · due 05/Nov',
  'bod.ov.attn': 'Attention',
  'bod.ov.setGoal': 'Set goals',
  'bod.ov.test': 'Send test',
  'bod.ov.chg': 'Change schedule',
  'bod.ov.job': 'Jobs in period',
  'bod.ov.hc': 'Headcount',
  'bod.ov.people': 'people',
  'bod.ov.hcSub': '2 joined · 1 left',
  'bod.ov.slaSub': '3 overdue mails today',
  'bod.ov.fleet': 'Fleet',
  'bod.ov.fleetSub': 'vehicles running · 94% on time',
  'bod.ov.pin': 'Pin to Overview · {k}',
  'bod.ov.unpin': 'Unpin · {k}',
  'bod.ov.asg': 'Comment / assign · {k}',
  'bod.ov.asgT': 'Comment / assign',
  'bod.ov.pinMax': 'Max 6 pinned metrics · unpin one first',
  'bod.ov.g.ok': 'On track',
  'bod.ov.g.mid': 'Slightly behind',
  'bod.ov.g.bad': 'Behind',
  'bod.ov.g.pct': '{p} of target · {t}% of time elapsed',
  'bod.ov.g.mk': 'Time-elapsed marker',
  'bod.ov.g.yoy': 'last year {v} · {d}',
  'bod.ov.q1': 'Why did October jobs rise vs September?',
  'bod.ov.a1': 'Jobs Oct/2026: 501, Sep/2026: 379 (+32.2%).\nMostly OB: 419 vs 306 (+113), most on CNNGB and KRPUS. LS +8, TR flat.\nSeptember was low due to the 2/9 holiday (per WorkCalendar) and 2 carriers cutting sailings.',
  'bod.ov.q2': 'Which department is late most this quarter?',
  'bod.ov.a2': 'Q4/2026 (to 22/Oct): CS 3, OPS 1, SALE 1.\nCS is 2 over the alert limit; 2 of 3 fell on Mondays. Shift start follows WorkCalendar (tblClientInfo).',
  'bod.ov.q3': 'Which mailbox is dragging SLA down?',
  'bod.ov.a3': 'support@ 89%, below the 90% limit. 2 of 3 overdue mails today are support@, all late afternoon.\nAverage reply support@ 26′, others 12–21′.',
  'bod.ov.q4': 'Which vehicle is late most this month?',
  'bod.ov.a4': '50E-139.70: 88% on time, 4 trips > 1h late, all Cat Lai → Binh Duong at peak hours.\nThis vehicle is also due for inspection on 05/Nov.',
  'bod.ov.askS': 'ask about figures · with sources',
  'bod.ov.askIn': 'Ask HANA about figures',
  'bod.ov.askPh': 'Ask about figures · e.g. why did support@ SLA drop?',
  'bod.ov.askGo': 'Ask',
  'bod.ov.free': 'Your question',
  'bod.ov.freeA': 'This question is not in the board sample data. In production Ask HANA looks up Lys figures per your permissions and cites each number.',
  'bod.ov.src': 'Sources',
  'bod.ov.ro': 'Read-only · never assigns or sends on its own',
  'bod.ov.asgFrom': 'Assign from here',
  'bod.ov.askHint': 'Answers cite board, table and period. Read-only per your permissions.',
  'bod.ov.openAt': 'Open in {app}',
  'bod.ov.asgOf': 'Assign · {k}',
  'bod.ov.trend': '12-month trend',
  'bod.ov.trendS': 'jobs per month · orange line = same period last year',
  'bod.ov.trendA': 'Jobs per month vs same period last year',
  'bod.ov.ly': 'Same period last year',
  'bod.ov.peak': 'peak {v} jobs',
  'bod.ov.pinned': 'Pinned',
  'bod.ov.pinnedS': '{n}/6 metrics · pin from any metric in Lys',
  'bod.ov.pinNone': 'Nothing pinned. Press the pin icon on a metric (Overview, People, SLA, Fleet) to bring it to the top.',
  'bod.ov.gY': '2026 goals',
  'bod.ov.gYS': 'actual / target · vertical mark = time elapsed',
  'bod.ov.gQ': 'Q4/2026 goals',
  'bod.ov.gQS': 'to 22/Oct/2026',
  'bod.ov.y2026': 'year 2026',
  'bod.ov.teu': 'converted from containers',
  'bod.ov.newc': 'New customers',
  'bod.ov.newcS': 'first job',
  'bod.ov.attnS': 'from every zone · open the source screen',
  'bod.ov.a.loss': 'Loss-making jobs',
  'bod.ov.a.lossS': '3 jobs have a KPE incident',
  'bod.ov.a.cut': 'Cut-off < 48h without SI / VGM',
  'bod.ov.a.cutS': 'cut-off per carrier SOP',
  'bod.ov.a.mail': 'Customer mails over SLA',
  'bod.ov.a.chat': 'Customer chat waiting > 30′',
  'bod.ov.a.hd': 'Labor contracts expiring in 30 days',
  'bod.ov.a.xe': 'Vehicle inspection due',
  'bod.ov.a.kpe': 'Incidents awaiting BOD',
  'bod.ov.cmp': 'Vs previous period',
  'bod.ov.cmpS': 'up / down · same period last year',
  'bod.ov.cmpJob': 'Jobs · same period last year',
  'bod.ov.cmpCus': 'Customers with jobs',
  'bod.ov.cmpMail': 'Avg mail reply',
  'bod.ov.cmpMailV': '18′ · 3′ faster',
  'bod.ov.cmpLate': 'Late arrivals',
  'bod.ov.cmpLateV': '5 · +2',
  'bod.ov.cmpFl': 'On-time trips',
  'bod.ov.cmpFlV': '94% · −1 pt',
  'bod.ov.asgP': 'Comments & assigned tasks',
  'bod.ov.asgPS': 'from metrics · assignee notified in Hei',
  'bod.ov.asgD1': 'Due in 2 working days',
  'bod.ov.asgD2': 'Comment',
  'bod.ov.news': 'Scheduled digest',
  'bod.ov.newsS': 'on · Mail + Hei',
  'bod.ov.nw1': 'Schedule',
  'bod.ov.nw1v': 'Weekly · Monday · 07:30',
  'bod.ov.nw2': 'Hours & holidays',
  'bod.ov.nw2v': 'per WorkCalendar',
  'bod.ov.nw3': 'Content',
  'bod.ov.nw3v': 'Pinned metrics + Attention',
  'bod.ov.nw4': 'Recipients',
  'bod.ov.nw5': 'Next send',
  'bod.ov.nw5v': 'Monday 26/Oct/2026 · 07:30',
  'bod.hr.k.now': 'Current headcount',
  'bod.hr.k.in': 'New joiners',
  'bod.hr.k.inSub': 'this period',
  'bod.hr.k.out': 'Leavers',
  'bod.hr.k.outSub': '12-month rate 8% · limit 10%',
  'bod.hr.k.late': 'Late / early leave',
  'bod.hr.turn': 'times',
  'bod.hr.k.lateSub': 'alert limit 6',
  'bod.hr.k.leave': 'Annual leave used',
  'bod.hr.k.leaveSub': '4 people with > 10 days left',
  'bod.hr.k.review': 'Year-end review',
  'bod.hr.k.reviewSub': 'self-assessed',
  'bod.hr.ch1': 'Headcount, 12 months',
  'bod.hr.ch1s': 'people at month end · source Mee · TblStaff',
  'bod.hr.ch1y': 'peak 36 people',
  'bod.hr.byDept': 'Late by department',
  'bod.hr.byDeptS': 'this period · limit 2',
  'bod.hr.ch2': 'Late / early leave by month',
  'bod.hr.ch2s': 'times · shift start per WorkCalendar',
  'bod.hr.ch2m': 'Alert limit 6',
  'bod.hr.ch3': 'Overtime by month',
  'bod.hr.ch3s': 'hours · per WorkCalendar (tblClientInfo)',
  'bod.hr.ch3l': 'Overtime hours',
  'bod.hr.ch3y': 'peak 70 h',
  'bod.hr.rank': 'Department ranking',
  'bod.hr.ranks': 'this period · no salary',
  'bod.hr.c.dept': 'Department',
  'bod.hr.c.n': 'Staff',
  'bod.hr.c.late': 'Late',
  'bod.hr.c.leave': 'Leave used',
  'bod.hr.c.ot': 'Overtime (h)',
  'bod.hr.c.err': 'Active incidents',
  'bod.hr.c.rew': 'Rewards',
  'bod.hr.c.prod': 'Productivity',
  'bod.hr.mile': 'Alert limits',
  'bod.hr.mileS': 'anything over the limit shows on Overview',
  'bod.hr.a1': 'CS late arrivals over limit',
  'bod.hr.a1s': 'limit 2 / department / month',
  'bod.hr.a3': 'Leave > 10 days left at year end',
  'bod.hr.a3s': 'remind to book before 31/Dec',
  'bod.hr.a4': 'Year-end self-review pending',
  'bod.hr.a4s': 'per review calendar',
  'bod.hr.a5': '12-month turnover',
  'bod.hr.a5s': 'below the 10% limit',
  'bod.hr.prod': 'Productivity',
  'bod.hr.prodS': 'no salary',
  'bod.hr.p1': 'Jobs / ops staff',
  'bod.hr.p2': 'Mails handled / CS / day',
  'bod.hr.p3': 'Trips / driver',
  'bod.hr.p4': 'Overtime hours',
  'bod.hr.p4v': '64 h · per WorkCalendar',
  'bod.hr.dept': 'By department',
  'bod.hr.deptS': 'source HANA Mee · TblStaff',
  'bod.hr.ppl': 'Watch list · individuals',
  'bod.hr.pplS': 'late in period · open profile',
  'bod.hr.times': '{n} times',
});
